<div class="box">
  <i class="feather" [attr.data-feather]="icon"></i>
  <h3 class="label">{{title}}</h3>
</div>
